import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as TabilifeLogo } from '../../assets/icon/tabi-life-black.svg';

const SessionBlocker: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 font-vn overflow-hidden">
      <div className="bg-white/80 h-full w-full px-4 flex items-center justify-center">
        <div className="bg-white px-4 py-5 w-full max-w-2xl rounded-xl shadow-modalWhite">
          <div className="not-italic pb-3">{t('THANK_YOU')}</div>
          <div className="flex flex-col gap-3 pb-5">{t('PLEASE_SCAN_QRCODE')}</div>
          <div className="w-full flex gap-1 items-center justify-center">
            <p className="text-gray-700 text-sm font-medium leading-5 notranslate" translate="no">
              {t('POWERED_BY')}
            </p>
            <TabilifeLogo width={100} height={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionBlocker;
